<template>
  <GfrDialog
    :show="show"
    class-name="com-access-tip-dialog"
    transition="slide-down"
    placement="top"
    :confirm-text="formatTransify('UGC_OFFICIAL_WEBSITE_DOWNLOAD_CONFIRM')"
    :closeable="false"
    @update:show="onUpdateShow"
    @confirm="onConfirm"
  >
    <template #title>
      <GfrTitle class="com-access-tip-dialog-title" :level="2" placement="center">
        <span class="com-access-tip-dialog-text">{{ title }}</span>
      </GfrTitle>
    </template>
    <template #content>
      <div class="com-access-tip-dialog-ctx">
        <GfrScrollBar class="com-access-tip-dialog-scroll" always>
          <div class="com-access-tip-dialog-content" v-html="desc"></div>
        </GfrScrollBar>
      </div>
    </template>
  </GfrDialog>
</template>
<script lang="ts" setup>
const props = defineProps({
  show: Boolean,
  title: String,
  desc: String,
  url: String
})
const emit = defineEmits(['update:show'])
const { formatTransify } = useStore()
const onUpdateShow = (value: boolean) => {
  emit('update:show', value)
}

const onConfirm = () => {
  // todo redirect link
  window.location.href = props.url as string
}
</script>
<style lang="scss">
.com-access-tip-dialog {
  @apply h-[246px] w-[480px] bg-[#2b2d32];
  // mobile portrait
  @apply max-lg:w-[334px] max-lg:h-[178px];
}

.com-access-tip-dialog-title {
  @apply relative line-clamp-1 h-[60px] py-4 font-medium uppercase;
  @apply text-[20px]/[28px] text-white;
  @apply after:absolute after:bottom-0 after:left-0 after:h-[1px] after:w-full after:bg-[#f0f0f0]/[.1] after:content-[""];
  // mobile portrait
  @apply max-lg:h-10 max-lg:py-2 max-lg:text-[16px]/[24px];
}

.com-access-tip-dialog-ctx {
  @apply h-[114px] w-full overflow-y-auto p-6;
  @apply text-[14px]/[22px];
  // mobile portrait
  @apply max-lg:px-6 max-lg:py-4 max-lg:h-[88px] max-lg:text-[12px]/[18px];
}

.gfr-dialog-button-group {
  @apply flex h-[72px] w-full items-start justify-center pt-4;
  // mobile portrait
  @apply max-lg:h-[52px] pt-2;
}

.gfr-dialog-button-confirm {
  @apply rounded-[2px] px-[43.5px] py-[5px] text-[14px]/[22px] font-bold uppercase text-[#2c2a2a];
  // mobile portrait
  @apply max-lg:h-[28px] max-lg:py-[5px] max-lg:text-[12px]/[18px];
}

.com-access-tip-dialog-content {
  * {
    color: #fff;
    line-height: normal;
  }

  p {
    font-size: 14px;
    line-height: 22px;
    @apply max-lg:text-[12px]/[18px];
  }
}

.com-access-tip-dialog-content {
  &:deep(p) {
    font-size: 14px;
    line-height: 22px;
  }

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #4d5158;
    border-radius: 0;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
  }
}
</style>
<style lang="scss" scoped>
.com-access-tip-dialog-scroll {
  height: 100%;
  padding-right: 16px;
}
</style>
